import React from 'react';
import Paper from '@mui/material/Paper';

const style = {
    paper: {
        padding:"10px 20px 10px 20px",
    }
}

var Fehlerbox = (props) => {
  if (props.inhalt.length < 1) {
    return '';
  }
  return (
    <Paper style={style.paper}>
        {props.inhalt}
    </Paper>
  );
}

export default Fehlerbox;
